<script lang="ts">
	import { CircleWithWarning, AdaptiveTextInput, XIcon } from "@hitit/new_ui";
	import { addSpacer } from "../../../functions/utils/phone";
	import { t } from "@hitit/hub/src/stores";
	import { onlyNumberHandler } from "../../utils";
	import IKS from "./IKS.svelte";
	import { createEventDispatcher } from "svelte";

	export let call = "";
	export let editmode = false;

	const dispatch = createEventDispatcher();
	const updateCall = (value: string) => {
		dispatch("UPDATE_CALL_NUMBER", {
			callNumber: value,
		});
	};
	const inputHandler = (e: Event) => {
		const target = e.currentTarget as HTMLInputElement;
		onlyNumberHandler(target, (_, v) => updateCall(v));
	};

</script>

<IKS name={'전화번호'} slotHasPadding>
	<img src="/img/icons/placeCall.png" alt="Call Icon" slot="image" />
	<div class="container">
		{#if editmode}
			<div class="input-box">
				<AdaptiveTextInput
					on:input={inputHandler}
					value={call}
					backgroundColor={'transparent'}
					noFocusoutline
					tel>
					<div class="x-icon" slot="clear" on:click={() => updateCall('')}>
						<XIcon />
					</div>
				</AdaptiveTextInput>
			</div>
		{:else if call}
			<p class="call">{addSpacer(call, ' ')}</p>
		{:else}
			<div class="no-call">
				<div class="circle">
					<CircleWithWarning />
				</div>
				<p class="desc">{$t('hub.place.No_has_call')}</p>
			</div>
		{/if}
	</div>
</IKS>

<style lang="scss">
	@import "../../../variables.scss";

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.container {
		color: #46474b;

		.input-box {
			width: 100%;
			height: 30px;
			background-color: #f0f0f4;
			border-radius: 20px;
			font-weight: 200;

			.x-icon {
				display: flex;
				width: 15px;
				height: 15px;

				&:hover {
					cursor: pointer;
				}
			}
		}

		.call {
			font-weight: 500;
		}
		.no-call {
			display: flex;
			align-items: center;
			gap: 10px;

			.circle {
				width: 20px;
				height: 20px;
			}
		}
	}

	@include DesktopSize {
		.container {
			.input-box {
				max-width: 400px;
				padding: 3px 5px;
				height: 40px;
				box-sizing: border-box;
				font-size: 1.25rem;
			}

			.call {
				font-size: 1.25rem;
			}
			.no-call {
				.circle {
					width: 24px;
					height: 24px;
				}
				.desc {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
